module.exports = "/shippingf450ffe05d562df44358750d6274f7e8.jpg";